import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { valFile } from "../../utils/ValidationFunctions";

import styles from "./ChatMessageInput.module.scss";

type Props = {
  sendMessageHandler: (msg: string, img?: File) => void;
  sendDisabled: boolean;
};

const ChatMessageInput: React.FC<Props> = ({
  sendMessageHandler,
  sendDisabled,
}) => {
  const [message, setMessage] = useState<string>("");
  const [img, setImg] = useState<File | undefined>(undefined);
  const [imgError, setImgError] = useState<boolean>(false);
  const [isFocus, setIsFocus] = useState<boolean>(false);

  const replaceLineFeed = (text: string) => {
    return text
      .replace(/\n{3,}/g, "\n\n")
      .replace(/(\r\n){3,}/g, "\r\n\r\n")
      .replace(/\r{3,}/g, "\r\r");
  };

  const checkLineFeed = (text: string) => {
    const allowLineFeeds = ["\n", "\n\n", "\r", "\r\r", "\r\n", "\r\n\r\n"];
    return allowLineFeeds.some((el: string) => el === text);
  };

  return (
    <div className={styles["f-chatMessageInput"]}>
      {img && (
        <div className={styles["f-chatMessageInput__preview"]}>
          <img src={URL.createObjectURL(img)} />
          <button
            className={styles["f-chatMessageInput__preview-btn"]}
            onClick={() => setImg(undefined)}
          >
            <FontAwesomeIcon icon={["fal", "times-circle"]} />
          </button>
        </div>
      )}
      <div className={styles["f-chatMessageInput__input"]}>
        <textarea
          className={
            isFocus
              ? `${styles["f-chatMessageInput__input__textarea"]} ${styles["focus"]}`
              : styles["f-chatMessageInput__input__textarea"]
          }
          autoComplete="off"
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && e.shiftKey) {
              e.preventDefault();
              const replaceMessage = replaceLineFeed(message);

              if (checkLineFeed(replaceMessage) || (!message && !img)) return;

              sendMessageHandler(replaceMessage, img);
              setMessage("");
              setImg(undefined);
            }
          }}
          onFocus={() => {
            setIsFocus(true);
          }}
          onBlur={(e) => {
            if (e.relatedTarget?.id === "file") {
              setTimeout(() => {
                setIsFocus(false);
              }, 500);
            } else {
              setIsFocus(false);
            }
          }}
          value={message}
          disabled={sendDisabled}
          placeholder={
            sendDisabled ? "現在メッセージを送ることはできません。" : undefined
          }
        />
        <button
          className={`${styles["f-chatMessageInput__input-btn"]} ${
            sendDisabled && styles["disabled"]
          }`}
          type="button"
          disabled={sendDisabled}
          id="file"
        >
          <label htmlFor="img">
            <FontAwesomeIcon icon={["fas", "image"]} />
          </label>
          <input
            id="img"
            type="file"
            hidden={true}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              if (e.target.files) {
                if (!valFile(e.target.files[0])) {
                  setImgError(true);
                } else {
                  setImgError(false);
                  setImg(e.target.files[0]);
                }
              }
            }}
          />
        </button>
        <button
          type="button"
          onMouseDown={() => {
            if (sendDisabled) return;
            const replaceMessage = replaceLineFeed(message);

            if (checkLineFeed(replaceMessage) || (!message && !img)) return;

            sendMessageHandler(message, img);
            setMessage("");
            setImg(undefined);
          }}
          className={`${styles["f-chatMessageInput__input-btn"]} ${
            sendDisabled && styles["disabled"]
          }`}
          disabled={sendDisabled}
        >
          <FontAwesomeIcon icon={["fas", "paper-plane"]} />
        </button>
      </div>
      <div className={styles["f-chatMessageInput__help"]}>
        Shift + Enter で送信できます
      </div>
      {imgError && (
        <p className={styles["f-chatMessageInput__error"]}>
          ファイルサイズが大きすぎます。
        </p>
      )}
    </div>
  );
};

export default ChatMessageInput;
